export default __webpack_public_path__ + "static/media/2020-1.41c4b348.jpg";